/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 10/01/2014
 * Time: 08:09
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').
    factory('CureItemView',["$sce","$dialog","CureItemData","CureSrv","CureItem","CureItemToServiceView","CureItemToService","CureItemToServiceData", "CureItemSrv", "gettextCatalog",
        function ($sce,$dialog,CureItemData,CureSrv,CureItem,CureItemToServiceView,CureItemToService,CureItemToServiceData,CureItemSrv, gettextCatalog)
        {

        var CureItemView = function (cureItem,cIndex,saleCureView,domainView)
        {
            this.cIndex = cIndex;
            this.domainView = domainView;
            this.saleCureView = saleCureView;
            this.cureItemToServicesView = [];
            this.cureItemId = null;
            this.useForm = {
                displayError : false,
                servicesView : [],  //global array sorted by date
                cureItemToServiceUsagesView : [] //global array sorted by date
                };
            this.isUsed = false;
            this.isClosed = false;
            if (cureItem!==undefined && cureItem!=null)
                this.loadDataFrom(cureItem);
        }
        CureItemView.prototype.getModel = function()
        {
            if (this.cIndex!=-1)
            {
                return CureItemData.getByIndex(this.cIndex);
            }
            return null;
        }

        CureItemView.prototype.loadDataFrom = function(cureItem)
        {
            this.cureItemToServicesView = [];
            this.cureItemId = cureItem.id;
            this.isClosed = cureItem.isClosed;
            this.isUsed =  cureItem.isUsed();
            var cureToServiceView;
            for (var i=0;i<cureItem.cureItemToServices.length;i++)
            {
                cureToServiceView = new CureItemToServiceView(cureItem.cureItemToServices[i],CureItemToServiceData.getIndexOf(cureItem.cureItemToServices[i]),this,this.domainView);
                this.cureItemToServicesView.push(cureToServiceView);
            }
        };
        CureItemView.prototype.reloadModel = function() {
            // consider cureItemToServicesView list is never changed (can't add or remove after creation)
            var cureItem = this.getModel();
            if (cureItem!=null)
            {
                for (var i=0;i<this.cureItemToServicesView.length;i++)
                    this.cureItemToServicesView[i].reloadModel();
            }
        };

        CureItemView.prototype.close = function(callbackFunction)
        {
            var cureItem = this.getModel();
            if (cureItem && !cureItem.isUsed())
            {
                var ciV = this;
                var msgDescription = gettextCatalog.getString("Attention, cette opération ne peut pas être annulée");
                var msgQuestion = gettextCatalog.getString("Voulez-vous vraiment clôturer cette cure");
                var opts = {
                    backdrop: true,
                    keyboard: true,
                    backdropClick: false,
                    templateUrl: '/partials/global/generalConfirm.html',
                    controller: 'DialogCtrl',
                    resolve: {
                        dialogsModel: function () {
                            var tableModel = [];
                            tableModel["question"] = msgQuestion+" ?";
                            tableModel["description"] = msgDescription ;
                            return tableModel;
                        }}};

                var d = $dialog.dialog(opts);
                d.open().then(function (result) {
                    if (result) {
                        ciV.isClosed = true;
                        ciV.updateModel(true, callbackFunction);
                        //load views

                        if (cureItem && cureItem.saleCure && cureItem.saleCure.sale && cureItem.saleCure.sale.customer) {
                            var customerView = ciV.domainView.getCustomerView(cureItem.saleCure.sale.customer);
                            if (customerView)
                                customerView.initHistoryView();
                        }
                        if (ciV.domainView && ciV.domainView.posView && ciV.domainView.posView.posSaleHistoryView)
                            ciV.domainView.posView.posSaleHistoryView.loadCuresData();
                    }
                });
            }
        }

        CureItemView.prototype.copyDataTo = function(cureItem)
        {

            if (cureItem)
            {
                var oldCureItemToServices = cureItem.cureItemToServices;
                cureItem.isClosed = this.isClosed;
                cureItem.cureItemToServices = [];
                var cureItemToService = null;
                for (var i=0;i<this.cureItemToServicesView.length;i++)
                {
                    if (i<oldCureItemToServices.length)//copy exising
                        cureItemToService = oldCureItemToServices[i];
                    else
                        cureItemToService = new CureItemToService(null,cureItem);

                    this.cureItemToServicesView[i].copyDataTo(cureItemToService);
                    cureItem.cureItemToServices.push(cureItemToService);

                }
            }
        };
        CureItemView.prototype.hasCureItemUsage = function()
        {
            var hasUsage = false;
            for (var i=0;i<this.cureItemToServicesView.length&&!hasUsage;i++)
                hasUsage = this.cureItemToServicesView[i].hasCureItemUsage() ;
            return hasUsage;
        };
        CureItemView.prototype.updateServiceSelectableForCure = function(servicesView)//
        {
            var serviceView=null;
            for (var i=0;i<this.cureItemToServicesView.length;i++) {
                serviceView = this.cureItemToServicesView[i].updateServiceSelectableForCure();
                if (serviceView && servicesView && servicesView.indexOf(serviceView)==-1)
                    servicesView.push(serviceView);
            }
        };
        CureItemView.prototype.getCureItemToServiceUsageView= function(cureItemToServiceUsage)
        {
            if (cureItemToServiceUsage && cureItemToServiceUsage.cureItemToService)
                for (var i =0;i<this.cureItemToServicesView.length;i++)
                    if (this.cureItemToServicesView[i].getModel()===cureItemToServiceUsage.cureItemToService)
                        return this.cureItemToServicesView[i].getCureItemToServiceUsageView(cureItemToServiceUsage);
            return null;
        };
        CureItemView.prototype.init = function(saleCureView)
        {
           this.saleCureView = saleCureView;
           if (saleCureView && saleCureView.cureView)
           {
               var cureItemToServiceView;
                for (var i=0;i<saleCureView.cureView.cureToServicesView.length;i++)
                {
                    cureItemToServiceView = new CureItemToServiceView();
                    cureItemToServiceView.init(this,saleCureView.cureView.cureToServicesView[i]);
                    this.cureItemToServicesView.push(cureItemToServiceView);
                }
           }

        } ;
        CureItemView.prototype.addNewUsage = function()
        {
            // add by default on first cureItem
            if (this.cureItemToServicesView.length>0)
                this.cureItemToServicesView[0].addNewUsage();
        };
        CureItemView.prototype.getFirstCureItemToServiceViewByServiceView= function(serviceView)
        {
            var cureItemToServiceView = null;
            for (var i =0;i<this.cureItemToServicesView.length && !cureItemToServiceView;i++)
                if (this.cureItemToServicesView[i].serviceView === serviceView && !this.cureItemToServicesView[i].isUsed())
                    cureItemToServiceView = this.cureItemToServicesView[i];
            return cureItemToServiceView;
        };
        CureItemView.prototype.updateModelUsage = function() {
            for (var i=0;i<this.cureItemToServicesView.length;i++)
                this.cureItemToServicesView[i].updateModel(true);
        }
        CureItemView.prototype.updateModel = function(save, callbackFunction)
        {
            var cureItem = this.getModel();
            if (cureItem==null)
            {
                cureItem = new CureItem();
                this.cIndex = CureItemData.getIndexOf(cureItem);
            }

            this.copyDataTo(cureItem);
            if (save!== undefined && save) {
                CureItemSrv.save(cureItem, callbackFunction);
            }
        }

        CureItemView.prototype.canSave = function()
        {
            for (var i =0;i<this.cureItemToServicesView.length;i++)
                if (this.cureItemToServicesView[i].usedQuantity>this.cureItemToServicesView[i].quantity)
                    return false;
            return true;
        };
        CureItemView.prototype.removeModel = function()
        {
        }
        CureItemView.prototype.initUseForm = function()
        {
            this.useForm.displayError = false;
            this.useForm.servicesView = [];  //global array sorted by date
            this.useForm.cureItemToServiceUsagesView = []; //global array sorted by date
            for (var i =0;i<this.cureItemToServicesView.length;i++)
                this.cureItemToServicesView[i].initUseForm();
        };

        return CureItemView;
    }
    ]);


// WEBPACK FOOTER //
// ./js/services/views/CureItemView.js